import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './layout';
import { invoice } from './proxyurls';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function Invoice() {
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [invoicesPerPage] = useState(100);
  const [successMessage, setSuccessMessage] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [SearchEmail, setSearchEmail] = useState('');
  const [SearchInvoiceID, setSearchInvoiceID] = useState('');
  const [usdTotal, setUsdTotal] = useState(0);
  const [totalReceivedPayment, setTotalReceivedPayment] = useState(0);

  const navigate = useNavigate();

  // Function to format USD currency with commas
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) {
      return '$0.00';
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parseFloat(amount));
  };

  const fetchInvoices = async () => {
    try {
      const params = {
        Email: SearchEmail,
        InvoiceID: SearchInvoiceID,
        startDate: startDate ? startDate.toISOString().split('T')[0] : '',
        endDate: endDate ? endDate.toISOString().split('T')[0] : '',
        page: currentPage,
        limit: invoicesPerPage,
      };

      const response = await axios.get(invoice, { params });

      setInvoices(response.data.invoices || []);
      setUsdTotal(response.data.totalUSD || 0);
      setTotalReceivedPayment(response.data.totalReceivedPayment || 0);
    } catch (error) {
      console.error('Error fetching invoices:', error);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, [SearchEmail, SearchInvoiceID, startDate, endDate, currentPage]);

  useEffect(() => {
    const msg = localStorage.getItem('successMessage');
    if (msg) {
      setSuccessMessage(msg);
      localStorage.removeItem('successMessage');
      setTimeout(() => setSuccessMessage(''), 3000);
    }
  }, []);

  const columns = [
    {
      name: 'Invoice ID',
      selector: (row) => row.invoice_id,
      sortable: true,
    },
    {
      name: 'Attorney',
      selector: (row) => (row.assigned ? `${row.assigned.firstname} ${row.assigned.lastname}` : ''),
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.assigned_email,
      sortable: true,
    },
    {
      name: 'Invoice Amount',
      selector: (row) => `${
  row.usd
    ? row.usd
    : Array.isArray(row?.invoiceReference)
      ? row.invoiceReference.reduce(
          (sum, item) => sum + parseFloat(item.usd || 0),
          0
        ).toFixed(2)
      : '0.00'
}`,

      sortable: true,
    },
    {
      name: 'Received Amount',
      selector: (row) => `${
  row.recieved_payment != 0
    ? row.recieved_payment
    : Array.isArray(row?.invoiceReference)
      ? row.invoiceReference.reduce(
          (sum, item) => sum + parseFloat(item.recieved_payment || 0),
          0
        ).toFixed(2)
      : '0.00'
}`,
      sortable: true,
    },
    {
      name: 'Age',
      selector: (row) => Math.floor((new Date() - new Date(row.created_at)) / (1000 * 60 * 60 * 24)),
      sortable: true,
    },
    {
      name: 'Invoice Date',
      selector: (row) => row.invoice_create_date,
      sortable: true,
    },
    {
      name: 'Status',
      cell: (row) =>
        row.latest_document_url ? (
          <a href={row.latest_document_url} target="_blank" rel="noopener noreferrer">
            <i style={{ color: '#4ab58e', fontSize: '18px' }} className="fa-solid fa-file-arrow-down"></i>
          </a>
        ) : (
          <i style={{ color: '#fc0404', fontSize: '18px' }} className="fa-solid fa-xmark iconss"></i>
        ),
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div className="btn-group">
          <button className="btn btn-outline-info" onClick={() => window.open(`/view-invoice/${row.id}`)}>
            <i className="fa fa-eye"></i>
          </button>
          <button className="btn btn-outline-warning" onClick={() => navigate(`/edit-invoice/${row.id}`)}>
            <i className="fa fa-edit"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      <section className="w-100 p-3">
        <div style={{ padding: '14px' }}>
          <div className="row border-bottom pb-2">
            <div className="col-md-2">
              <h4 className="pt-1">Manage Invoices</h4>
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control mb-3 form-control-sm"
                placeholder="Search Email"
                value={SearchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control mb-3 form-control-sm"
                placeholder="Search Invoice ID"
                value={SearchInvoiceID}
                onChange={(e) => setSearchInvoiceID(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  setCurrentPage(1);
                }}
                placeholderText="Start Date"
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  setCurrentPage(1);
                }}
                placeholderText="End Date"
                className="form-control form-control-sm mx-2"
              />
            </div>
            <div className="col-md-1">
              <button
                className="btn btn-outline-danger btn-sm"
                style={{ marginLeft: '18px' }}
                onClick={() => {
                  setStartDate(null);
                  setEndDate(null);
                  setSearchEmail('');
                  setSearchInvoiceID('');
                }}
              >
                Clear
              </button>
            </div>
            <div className="col-md-1 text-end px-0">
              <button
                type="button"
                className="btn btn-outline-success mt-1 btn-sm"
                style={{ marginLeft: 'auto', position: 'relative', top: '-5px' }}
                onClick={() => navigate('/add-invoice')}
              >
                Add Invoice
              </button>
            </div>
          </div>
          {invoices.length > 0 && (
            <>
              <div className="row invoice_bedge">
                <div className="col-md-6 text-center"><strong>Total USD Payment: {formatCurrency(usdTotal)}</strong></div>
                <div className="col-md-6 text-center"><strong>Total USD Recieved Payment: {formatCurrency(totalReceivedPayment)}</strong></div>
              </div>
            </>
          )}
          <DataTable
            columns={columns}
            data={invoices}
            pagination
            highlightOnHover
            defaultSortField="invoice_id"
            defaultSortAsc={true}
          />
        </div>
      </section>
    </Layout>
  );
}

export default Invoice;